/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `"Pinyon Script", cursive;`,
  subHeading: `"Nanum Myeongjo", serif;`,
  body: `"Nanum Myeongjo", serif;`,
  body_lv2: `"Cormorant Upright", serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    lineHeight: '1',
    textAlign: 'center',
    color: 'secondaryColorText',
    textTransform: 'lowercase',
    textStyle: 'heading',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    letterSpacing: '0.5px',
    textAlign: 'center',
    color: 'secondaryColorText',
    textStyle: 'subHeading',
  },
  body: {
    fontFamily: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'mainColorText',
    textStyle: 'body',
  },
};
